import React from "react";
import { Link } from "react-router-dom";
import Map from "../components/Map";
const Footer = () => {
  return (
    <footer className="footer-area">
      <div className="container">
        <div className="row">
          <div className="col-md-3">
            <div className="single-footer">
              <h3>About Us</h3>
              <ul className="footer-contact-info">
                <li>
                  <span>
                    <i className="icofont-location-pin pr-2 icons"></i>
                  </span>
                  8/195 Engineer's Colony, Opp. Omaxe Mall, Bye Pass Road, Agra
                  - 282005
                </li>
                <li>
                  <span>
                    <i className="icofont-phone pr-2 icons"></i>
                  </span>
                  <a href="tel:8077187959">+91 8077187959</a>
                </li>
                <li>
                  <span>
                    <i className="icofont-brand-whatsapp pr-2 icons"></i>
                  </span>
                  <a href="https://wa.me/919359587399" target="_blank">
                    +91 9359587399
                  </a>
                </li>
                <li>
                  <span>
                    <i className="icofont-email pr-2 icons"></i>
                  </span>
                  <a href="mailto:info@sarkarizone.com" target="_blank">
                    info@Sarkarizone.com
                  </a>
                </li>
              </ul>
              <ul className="social">
                <li>
                  <a
                    href="https://www.facebook.com/sarkarizone"
                    target="_blank"
                  >
                    <i className="icofont-facebook icons"></i>
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/sarkarizone" target="_blank">
                    <i className="icofont-twitter icons"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/in/sarkari-zone-3386361b9/"
                    target="_blank"
                  >
                    <i className="icofont-linkedin icons"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/sarkarizone"
                    target="_blank"
                  >
                    <i className="icofont-instagram icons"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://in.pinterest.com/sarkarizone/"
                    target="_blank"
                  >
                    <i className="icofont-pinterest icons"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UCKpimXxJeSGeuuVfoCtL2aQ/videos"
                    target="_blank"
                  >
                    <i className="icofont-youtube-play icons"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-2">
            <div className="single-footer">
              <h3>Links</h3>
              <ul className="list">
                <li>
                  <Link to="/about-us">About Us</Link>
                </li>
                <li>
                  <Link to="/gallery">Gallery</Link>
                </li>
                <li>
                  <Link to="/contact-us">Contact</Link>
                </li>
                <li>
                  <Link to="/our-facilities">Our Facilities</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-7">
            <Map />
          </div>
        </div>
      </div>
      <div className="copyright-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-md-7">
              <p>
                Copyright © {new Date().getFullYear()} All Rights Reserved by
                SarkariZone <br /> Design And Developed by
                <a
                  href="https://www.technosters.com"
                  target="_blank"
                  className="footer_name"
                >
                  {" "}
                  Technosters Technologies OPC Pvt. Ltd.
                </a>
              </p>
            </div>
            <div className="col-lg-5 col-md-5">
              <ul>
                <li>
                  <Link to="policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="terms-and-conditions">Terms & Conditions</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
